/** User-facing labels for CRM setup (API routes stay `/settings/...`). */

export const SETUP_NAV_LABEL = 'Setup';

export const SETUP_SECTION_SUBTITLE = 'Configure your CRM';

export const SETUP_STAGES_LABEL = 'Stages';

export const SETUP_SEGMENTS_LABEL = 'Segments';

export const SETUP_CATEGORIES_LABEL = 'Categories';
